import * as React from 'react';
import * as style from './OtherDeveloperCard.css';
import { ArticleParagraph2, Image, UIHeading4 } from '@cian/ui-kit';
import { EStarSize, EStarTheme, Star } from '@cian/frontend-reviews-components';

interface IOtherDeveloperCardProps {
  logo: string;
  rate: number;
  name: string;
  url: string;
  readyHouses: string;
  housesInProcess: string;
}

export const OtherDeveloperCard = ({
  logo,
  rate,
  name,
  url,
  readyHouses,
  housesInProcess,
}: IOtherDeveloperCardProps) => {
  return (
    <a className={style['card']} data-testid="OtherDeveloperCard" href={url}>
      <div className={style['heading']}>
        <div className={style['heading__logo']}>
          <Image src={logo} alt="logo" width={40} height={40} borderRadius="4px" />
          <div className={style['rating']}>
            <div className={style['ratings__star']}>
              <Star size={EStarSize.M} theme={EStarTheme.Filled} />
            </div>
            <UIHeading4 color="warning_100" fontWeight="700">
              {rate}
            </UIHeading4>
          </div>
        </div>
        <div>
          <ArticleParagraph2 color="gray60_100">Застройщик</ArticleParagraph2>
          <ArticleParagraph2 fontWeight="700">{name}</ArticleParagraph2>
        </div>
      </div>
      <div className={style['description']}>
        <div>
          <ArticleParagraph2 color="gray60_100">Сдано</ArticleParagraph2>
          <ArticleParagraph2 whiteSpace="pre-wrap">{readyHouses}</ArticleParagraph2>
        </div>
        <div>
          <ArticleParagraph2 color="gray60_100">Строится</ArticleParagraph2>
          <ArticleParagraph2 whiteSpace="pre-wrap">{housesInProcess}</ArticleParagraph2>
        </div>
      </div>
    </a>
  );
};
